import { render, staticRenderFns } from "./mainWeixiuManage.vue?vue&type=template&id=6e0cd28a&scoped=true&"
import script from "./mainWeixiuManage.vue?vue&type=script&lang=js&"
export * from "./mainWeixiuManage.vue?vue&type=script&lang=js&"
import style0 from "./mainWeixiuManage.vue?vue&type=style&index=0&id=6e0cd28a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0cd28a",
  null
  
)

export default component.exports